<template>
 <section class="content">
   <!-- Modal -->
   <div class="modal fade" id="confirmacaoModal" tabindex="-1" role="dialog" aria-labelledby="confirmacaoModalLabel" aria-hidden="true">
     <div class="modal-dialog modal-dialog-centered" role="document">
       <div class="modal-content panel-danger">
         <div class="modal-header panel-heading">
           <h4 class="modal-title" id="confirmacaoModalLabel">{{tituloModal}}</h4>
           <button type="button" class="close" data-dismiss="modal" aria-label="Close">
             <span aria-hidden="true">&times;</span>
           </button>
         </div>
         <div class="modal-body">
           {{mensagemModal}}
         </div>
         <div class="modal-footer">
           <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
           <button type="button" class="btn btn-primary" data-dismiss="modal" @click="deletarStatus(statusParaApagar)">Confirmar</button>
         </div>
       </div>
     </div>
   </div>
  
   <div>
     <b-alert variant="danger"
            dismissible
            :show="showDismissibleAlert"
            @dismissed="showDismissibleAlert=false">
     {{messageAlert}}
   </b-alert>
   </div>
   <div class="row center-block" v-show="exibirListagem">
     <h2>Listagem</h2>
     <div class="col-md-12" >
       <div class="box">
         <div class="box-header">
           <h3 class="box-title" v-show="!exibirNomeMaquina">Listagem das máquinas instaladas</h3>
           <h3 class="box-title" v-show="exibirNomeMaquina">Alterar Nome da Máquina</h3>
         </div>
         <!-- /.box-header -->
         <div class="box-body no-padding table-responsive" v-show="!exibirNomeMaquina">
           <table class="table table-striped">
             <tbody>
               <tr>
                 <th>Nome da Máquina</th>
                 <th>Mac Address</th>
                 <th>Instalada</th>
                 <th>Atualizada</th>
                 <th style="width: 40px">Legendas</th>
               </tr>
               <tr v-for="maquina in maquinas" :key="maquina.id">
                 <td><a class="btn btn-sm" v-on:click="alterarNomeMaquina(maquina)"><i class="fa fa-edit"></i>  {{maquina.nomemaquina}}</a></td>
                 <td>{{maquina.mac}}</td>
                 <td>{{maquina.created_at}}</td>
                 <td>{{maquina.updated_at}}</td>
                 <td><a class="btn btn-sm" v-on:click="detalharMaquina(maquina)"><span class="pull-right badge bg-blue"><i class="fa fa-edit"></i>  Editar</span></a></td>
               </tr>
             </tbody>
           </table>
         </div>
         <div class="box-body col-md-12" v-show="exibirNomeMaquina">
           <div class="form-group">
             <label for="nomeDaMaquina" class="col-sm-2 control-label">Máquina</label>
             <div class="col-sm-4">
               <input type="text" class="form-control form-control-sm" id="nomeDaMaquina" v-model="nomemaquinaTemporario">
             </div>
           </div>
         </div>
         <!-- /.box-body -->
         <div class="box-footer" v-show="exibirNomeMaquina">
           <div class="col-sm-1">
             <button type="button" v-on:click="voltarAtualizarNomeMaquina()" class="btn">Voltar</button>
           </div>
           <div class="col-sm-4">
             <button type="button" class="btn btn-primary" v-on:click="atualizarNomeMaquina()">Atualizar os Dados</button>
           </div>
         </div>
       </div>
     </div>
   </div>

   <div class="row center-block" v-show="!exibirListagem">
     <h2><a v-on:click="exibirListagem = true" >Listagem </a><small>Legendas</small></h2>
     <div class="col-md-12">
       <div class="box" v-show="exibirFuncao">
         <div class="box-header">
           <h3 class="box-title">{{maquinaDetalhe.nomemaquina}} - Funções</h3>
         </div>
         <!-- /.box-header -->
         <div class="box-body no-padding table-responsive">
           <div class="box-body no-padding table-responsive  col-md-12" v-show="!exibirAtualizarFuncao">
             <table class="table table-striped">
               <tbody>
                 <tr>
                   <th>Função</th>
                   <th>Não Acionada</th>
                   <th>F1</th>
                   <th>F2</th>
                   <th>F3</th>
                   <th>F4</th>
                   <th>F5</th>
                   <th>F6</th>
                 </tr>
                 <tr>
                   <th>Texto</th>
                   <td>{{funcoes.f0.texto}} <a class="btn btn-sm" v-on:click="selecionarFuncao(0)"><span class="pull-right badge bg-blue"><i class="fa fa-edit"></i></span></a></td>
                   <td>{{funcoes.f1.texto}} <a class="btn btn-sm" v-on:click="selecionarFuncao(1)"><span class="pull-right badge bg-blue"><i class="fa fa-edit"></i></span></a></td>
                   <td>{{funcoes.f2.texto}} <a class="btn btn-sm" v-on:click="selecionarFuncao(2)"><span class="pull-right badge bg-blue"><i class="fa fa-edit"></i></span></a></td>
                   <td>{{funcoes.f3.texto}} <a class="btn btn-sm" v-on:click="selecionarFuncao(3)"><span class="pull-right badge bg-blue"><i class="fa fa-edit"></i></span></a></td>
                   <td>{{funcoes.f4.texto}} <a class="btn btn-sm" v-on:click="selecionarFuncao(4)"><span class="pull-right badge bg-blue"><i class="fa fa-edit"></i></span></a></td>
                   <td>{{funcoes.f5.texto}} <a class="btn btn-sm" v-on:click="selecionarFuncao(5)"><span class="pull-right badge bg-blue"><i class="fa fa-edit"></i></span></a></td>
                   <td>{{funcoes.f6.texto}} <a class="btn btn-sm" v-on:click="selecionarFuncao(6)"><span class="pull-right badge bg-blue"><i class="fa fa-edit"></i></span></a></td>
                 </tr>
               </tbody>
             </table>
           </div>
           <div class="box-body col-md-12" v-show="exibirAtualizarFuncao">
             <div class="form-group">
               <label for="textoDaFuncao" class="col-sm-2 control-label">{{funcaoSelecionada.funcao}}</label>
               <div class="col-sm-4">
                 <input type="text" class="form-control" id="textoDaFuncao" v-model="funcaoSelecionada.texto">
               </div>
             </div>
           </div>
         </div>
         <!-- /.box-body -->
         <div class="box-footer" v-show="exibirAtualizarFuncao">
           <div class="col-sm-1">
             <button type="button" v-on:click="voltarAtualizarFuncao()" class="btn">Voltar</button>
           </div>
           <div class="col-sm-4">
             <button type="button" class="btn btn-primary" v-on:click="atualizarFuncao()">Atualizar Função</button>
           </div>
         </div>
       </div>
       <div class="box" v-show="exibirStatus">
         <div class="box-header">
           <h3 class="box-title">{{maquinaDetalhe.nomemaquina}} - Status</h3>
         </div>
         <!-- /.box-header -->
         <div class="box-body no-padding table-responsive">
           <div class="box-body no-padding table-responsive  col-md-12" v-show="!exibirAtualizarStatus">
             <table class="table table-striped">
               <tbody>
                 <tr>
                   <th>Status</th>
                   <th>Produzindo</th>
                   <th>IN1</th>
                   <th>IN2</th>
                   <th>IN3</th>
                   <th>IN4</th>
                   <th>IN5</th>
                   <th>IN6</th>
                   <th class="text-center">Ações</th>
                 </tr>
                 <tr v-for="legenda in legendas" :key="legenda.id" v-if="legenda.isfuncao === 0" >
                   <th>{{legenda.textolegenda}}</th>
                   <td>
                     <div>
                     <span class="badge bg-green" v-if="legenda.isoperando === 1">On</span>
                     <span class="badge" v-else>Off</span>
                   </div>
                   </td>
                   <td>
                     <div>
                     <span class="badge bg-green" v-if="intToBinaryString(legenda.valorlegenda)[7] === '1'">On</span>
                     <span class="badge" v-else>Off</span>
                   </div>
                   </td>
                   <td>
                     <div>
                     <span class="badge bg-green" v-if="intToBinaryString(legenda.valorlegenda)[6] === '1'">On</span>
                     <span class="badge" v-else>Off</span>
                   </div>
                   </td>
                   <td>
                     <div>
                     <span class="badge bg-green" v-if="intToBinaryString(legenda.valorlegenda)[5] === '1'">On</span>
                     <span class="badge" v-else>Off</span>
                   </div>
                   </td>
                   <td>
                     <div>
                     <span class="badge bg-green" v-if="intToBinaryString(legenda.valorlegenda)[4] === '1'">On</span>
                     <span class="badge" v-else>Off</span>
                   </div>
                   </td>
                   <td>
                     <div>
                     <span class="badge bg-green" v-if="intToBinaryString(legenda.valorlegenda)[3] === '1'">On</span>
                     <span class="badge" v-else>Off</span>
                   </div>
                   </td>
                   <td>
                     <div>
                     <span class="badge bg-green" v-if="intToBinaryString(legenda.valorlegenda)[2] === '1'">On</span>
                     <span class="badge" v-else>Off</span>
                   </div>
                   </td>
                   <td>
                     <div class="text-center">
                       <a class="btn btn-sm" v-on:click="selecionarStatus(legenda)"><span class="pull-right badge bg-blue"><i class="fa fa-edit"></i> Editar</span></a>
                       <a class="btn btn-sm" data-toggle="modal" data-target="#confirmacaoModal" v-on:click="prepararDeletarStatus(legenda)"><span class="pull-right badge bg-red"><i class="fa fa-trash"></i> Apagar</span></a>
                     </div>
                   </td>
                 </tr>
               </tbody>
             </table>
           </div>
           <div class="box-body col-md-12" v-show="exibirAtualizarStatus">
             <div class="form-group">
               <label for="textoDoStatus" class="col-sm-1 control-label">Status</label>
               <div class="col-sm-3">
                 <input type="text" class="form-control" id="textoDoStatus" v-model="statusSelecionado.textolegenda">
               </div>
               <label for="textoDoProduzindo" class="col-sm-1 control-label">Produzindo</label>
               <div class="col-sm-1">
                 <input type="checkbox" id="textoDoStatus" v-model="statusSelecionado.isoperando">
               </div>
               <div class="col-sm-6">
                 <label for="textoDoProduzindo" class="col-sm-1 control-label">IN1</label>
                 <div class="col-sm-1">
                   <input type="checkbox" id="textoDoStatus" v-model="statusSelecionado.in1">
                 </div>
                 <label for="textoDoProduzindo" class="col-sm-1 control-label">IN2</label>
                 <div class="col-sm-1">
                   <input type="checkbox" id="textoDoStatus" v-model="statusSelecionado.in2">
                 </div>
                 <label for="textoDoProduzindo" class="col-sm-1 control-label">IN3</label>
                 <div class="col-sm-1">
                   <input type="checkbox" id="textoDoStatus" v-model="statusSelecionado.in3">
                 </div>
                 <label for="textoDoProduzindo" class="col-sm-1 control-label">IN4</label>
                 <div class="col-sm-1">
                   <input type="checkbox" id="textoDoStatus" v-model="statusSelecionado.in4">
                 </div>
                 <label for="textoDoProduzindo" class="col-sm-1 control-label">IN5</label>
                 <div class="col-sm-1">
                   <input type="checkbox" id="textoDoStatus" v-model="statusSelecionado.in5">
                 </div>
                 <label for="textoDoProduzindo" class="col-sm-1 control-label">IN6</label>
                 <div class="col-sm-1">
                   <input type="checkbox" id="textoDoStatus" v-model="statusSelecionado.in6">
                 </div>
               </div>
             </div>
           </div>
         </div>
         <!-- /.box-body -->
         <div class="box-footer">
           <div class="col-sm-1" v-show="!exibirAtualizarStatus">
             <button type="button" v-on:click="exibirListagem = true" class="btn">Voltar</button>
           </div>
           <div class="col-sm-4" v-show="!exibirAtualizarStatus">
             <button type="button" class="btn btn-primary" v-on:click="novoStatus()">Novo Status</button>
           </div>
           <div class="col-sm-1" v-show="exibirAtualizarStatus">
             <button type="button" v-on:click="voltarAtualizarFuncao()" class="btn">Voltar</button>
           </div>
           <div class="col-sm-4" v-show="exibirAtualizarStatus">
             <button type="button" class="btn btn-primary" v-on:click="atualizarStatus()">Atualizar os Dados</button>
           </div>
         </div>
       </div>
     </div>
   </div>
 </section>
</template>

<script>
export default {
  name: 'Maquinas',
  mounted() {
    if (window.localStorage.getItem('token') === null) {
      this.showDismissibleAlert = true
      this.messageAlert = 'Favor efetuar o login para visualizar os dados'
    }
  },
  computed: {
    legendas () {
      return this.$store.state.Legendas.all
    },
    maquinas () {
      return this.$store.state.Controladores.all
    },
    isMobile () {
      return (window.innerWidth <= 800 && window.innerHeight <= 600)
    }
  },
  data () {
    return {
      tituloModal: '',
      mensagemModal: '',
      statusParaApagar: {},
      showDismissibleAlert: false,
      messageAlert: '',
      maquinaDetalhe: {
        'id': 0,
        'mac': '',
        'nomemaquina': '',
        'created_at': '',
        'updated_at': ''
      },
      funcaoSelecionada: {
        idcontrolador: 0,
        funcao: 'Selecione Função',
        texto: '',
        valor: 0,
        idlegenda: 0
      },
      statusSelecionado: {
        id: 0,
        idcontrolador: 0,
        valorlegenda: 0,
        textolegenda: '',
        isfuncao: false,
        isoperando: false,
        in1: false,
        in2: false,
        in3: false,
        in4: false,
        in5: false,
        in6: false,
        valoralterado: 0
      },
      funcoes: {
        idcontrolador: 0,
        f0: {
          texto: '',
          idlegenda: 0
        },
        f1: {
          texto: '',
          idlegenda: 0
        },
        f2: {
          texto: '',
          idlegenda: 0
        },
        f3: {
          texto: '',
          idlegenda: 0
        },
        f4: {
          texto: '',
          idlegenda: 0
        },
        f5: {
          texto: '',
          idlegenda: 0
        },
        f6: {
          texto: '',
          idlegenda: 0
        }
      },
      errors: [],
      nomemaquinaTemporario: '',
      exibirAtualizarStatus: false,
      exibirAtualizarFuncao: false,
      exibirStatus: false,
      exibirFuncao: false,
      exibirListagem: true,
      exibirNomeMaquina: false
    }
  },
  methods: {
    alterarNomeMaquina: function(maquina) {
      this.exibirNomeMaquina = true
      this.maquinaDetalhe = maquina
      this.nomemaquinaTemporario = maquina.nomemaquina
    },
    popularFuncoes: function(listaLegendas) {
      listaLegendas.forEach(legenda => {
        if (legenda.isfuncao === 1) {
          this.funcoes.idcontrolador = legenda.idcontrolador
          switch (legenda.valorlegenda) {
            case 0:
              this.funcoes.f0.texto = legenda.textolegenda
              this.funcoes.f0.idlegenda = legenda.id
              break
            case 1:
              this.funcoes.f1.texto = legenda.textolegenda
              this.funcoes.f1.idlegenda = legenda.id
              break
            case 2:
              this.funcoes.f2.texto = legenda.textolegenda
              this.funcoes.f2.idlegenda = legenda.id
              break
            case 4:
              this.funcoes.f3.texto = legenda.textolegenda
              this.funcoes.f3.idlegenda = legenda.id
              break
            case 8:
              this.funcoes.f4.texto = legenda.textolegenda
              this.funcoes.f4.idlegenda = legenda.id
              break
            case 16:
              this.funcoes.f5.texto = legenda.textolegenda
              this.funcoes.f5.idlegenda = legenda.id
              break
            case 32:
              this.funcoes.f6.texto = legenda.textolegenda
              this.funcoes.f6.idlegenda = legenda.id
              break
          }
        }
      })
    },
    novoStatus: function() {
      this.exibirAtualizarStatus = true
      this.exibirFuncao = false
      this.statusSelecionado.id = 0
      this.statusSelecionado.idcontrolador = this.maquinaDetalhe.id
      this.statusSelecionado.valorlegenda = 0
      this.statusSelecionado.textolegenda = ''
      this.statusSelecionado.isfuncao = false
      this.statusSelecionado.isoperando = false
      this.statusSelecionado.in1 = false
      this.statusSelecionado.in2 = false
      this.statusSelecionado.in3 = false
      this.statusSelecionado.in4 = false
      this.statusSelecionado.in5 = false
      this.statusSelecionado.in6 = false
    },
    selecionarStatus: function(legendaSelecionada) {
      this.exibirAtualizarStatus = true
      this.exibirFuncao = false
      this.statusSelecionado.id = legendaSelecionada.id
      this.statusSelecionado.idcontrolador = legendaSelecionada.idcontrolador
      this.statusSelecionado.valorlegenda = parseInt(legendaSelecionada.valorlegenda)
      this.statusSelecionado.textolegenda = legendaSelecionada.textolegenda
      this.statusSelecionado.isfuncao = parseInt(legendaSelecionada.isfuncao)
      this.statusSelecionado.isoperando = parseInt(legendaSelecionada.isoperando)
      this.statusSelecionado.in1 = Boolean(parseInt(this.intToBinaryString(legendaSelecionada.valorlegenda)[7]))
      this.statusSelecionado.in2 = Boolean(parseInt(this.intToBinaryString(legendaSelecionada.valorlegenda)[6]))
      this.statusSelecionado.in3 = Boolean(parseInt(this.intToBinaryString(legendaSelecionada.valorlegenda)[5]))
      this.statusSelecionado.in4 = Boolean(parseInt(this.intToBinaryString(legendaSelecionada.valorlegenda)[4]))
      this.statusSelecionado.in5 = Boolean(parseInt(this.intToBinaryString(legendaSelecionada.valorlegenda)[3]))
      this.statusSelecionado.in6 = Boolean(parseInt(this.intToBinaryString(legendaSelecionada.valorlegenda)[2]))
    },
    selecionarFuncao: function(posicaoFuncao) {
      this.exibirAtualizarFuncao = true
      this.exibirStatus = false
      this.funcaoSelecionada.idcontrolador = this.funcoes.idcontrolador
      switch (posicaoFuncao) {
        case 0:
          this.funcaoSelecionada.funcao = 'Não Acionada'
          this.funcaoSelecionada.texto = this.funcoes.f0.texto
          this.funcaoSelecionada.idlegenda = this.funcoes.f0.idlegenda
          this.funcaoSelecionada.valor = 0
          break
        case 1:
          this.funcaoSelecionada.funcao = 'Função F1'
          this.funcaoSelecionada.texto = this.funcoes.f1.texto
          this.funcaoSelecionada.idlegenda = this.funcoes.f1.idlegenda
          this.funcaoSelecionada.valor = 1
          break
        case 2:
          this.funcaoSelecionada.funcao = 'Função F2'
          this.funcaoSelecionada.texto = this.funcoes.f2.texto
          this.funcaoSelecionada.idlegenda = this.funcoes.f2.idlegenda
          this.funcaoSelecionada.valor = 2
          break
        case 3:
          this.funcaoSelecionada.funcao = 'Função F3'
          this.funcaoSelecionada.texto = this.funcoes.f3.texto
          this.funcaoSelecionada.idlegenda = this.funcoes.f3.idlegenda
          this.funcaoSelecionada.valor = 4
          break
        case 4:
          this.funcaoSelecionada.funcao = 'Função F4'
          this.funcaoSelecionada.texto = this.funcoes.f4.texto
          this.funcaoSelecionada.idlegenda = this.funcoes.f4.idlegenda
          this.funcaoSelecionada.valor = 8
          break
        case 5:
          this.funcaoSelecionada.funcao = 'Função F5'
          this.funcaoSelecionada.texto = this.funcoes.f5.texto
          this.funcaoSelecionada.idlegenda = this.funcoes.f5.idlegenda
          this.funcaoSelecionada.valor = 16
          break
        case 6:
          this.funcaoSelecionada.funcao = 'Função F6'
          this.funcaoSelecionada.texto = this.funcoes.f6.texto
          this.funcaoSelecionada.idlegenda = this.funcoes.f6.idlegenda
          this.funcaoSelecionada.valor = 32
          break
      }
    },
    limparFuncoes: function() {
      this.limparFuncaoSelecionada()
      this.funcoes = {
        idcontrolador: 0,
        f0: {
          texto: '',
          idlegenda: 0
        },
        f1: {
          texto: '',
          idlegenda: 0
        },
        f2: {
          texto: '',
          idlegenda: 0
        },
        f3: {
          texto: '',
          idlegenda: 0
        },
        f4: {
          texto: '',
          idlegenda: 0
        },
        f5: {
          texto: '',
          idlegenda: 0
        },
        f6: {
          texto: '',
          idlegenda: 0
        }
      }
    },
    limparFuncaoSelecionada: function() {
      this.funcaoSelecionada = {
        idcontrolador: 0,
        funcao: 'Selecione Função',
        texto: '',
        valor: 0,
        idlegenda: 0
      }
    },
    detalharMaquina: function(maquina) {
      this.exibirStatus = true
      this.exibirFuncao = true
      this.exibirAtualizarStatus = false
      this.exibirAtualizarFuncao = false
      this.exibirListagem = false
      this.limparFuncoes()
      this.maquinaDetalhe = maquina
      this.$store.dispatch('listLegendas', maquina.id)
      .then(response => {
        this.popularFuncoes(this.legendas)
      })
      .catch(e => {
        this.errors.push(e)
      })
    },
    intToBinaryString: function (number) {
      var result = number.toString(2)
      while (Math.floor(result.length % 8) !== 0) {
        result = '0' + result
      }
      return result
    },
    binaryStringToInt: function (binario) {
      var result = binario[5] === '1' ? 1 : 0
      result = result + binario[4] === '1' ? 2 : 0
      result = result + binario[3] === '1' ? 4 : 0
      result = result + binario[2] === '1' ? 8 : 0
      result = result + binario[1] === '1' ? 16 : 0
      result = result + binario[0] === '1' ? 32 : 0
      return result
    },
    atualizarNomeMaquina: function() {
      this.$store.dispatch('updateControlador', {
        id: this.maquinaDetalhe.id,
        controlador: {
          nomemaquina: this.nomemaquinaTemporario,
          mac: this.maquinaDetalhe.mac
        }
      })
    .then(response => {
      this.maquinaDetalhe = response.data
      this.$store.dispatch('listControladores')
      this.exibirNomeMaquina = false
    })
    .catch(e => {
      this.errors.push(e)
    })
    },
    voltarAtualizarNomeMaquina: function() {
      this.exibirNomeMaquina = false
    },
    voltarAtualizarFuncao: function() {
      this.detalharMaquina(this.maquinaDetalhe)
    },
    atualizarFuncao: function() {
      if (this.funcaoSelecionada.idlegenda === 0) {
        this.$store.dispatch('createLegenda', {
          textolegenda: this.funcaoSelecionada.texto,
          idcontrolador: this.maquinaDetalhe.id,
          isfuncao: 1,
          isoperando: 0,
          valorlegenda: this.funcaoSelecionada.valor
        })
        .then(response => {
          this.detalharMaquina(this.maquinaDetalhe)
        })
        .catch(err => {
          if (err.response.status === 403) {
            this.showDismissibleAlert = true
            this.messageAlert = 'Você não possui privilégios para executar essa ação. Favor entrar em contato o responsável pelo sistema'
          } else {
            this.showDismissibleAlert = true
            this.messageAlert = 'Falha ao alterar a Função. Favor entrar em contato o administrador do sistema informando a mensagem: ' + err
          }
        })
      } else {
        this.$store.dispatch('updateLegenda', {
          id: this.funcaoSelecionada.idlegenda,
          legenda: {
            textolegenda: this.funcaoSelecionada.texto,
            idcontrolador: this.funcaoSelecionada.idcontrolador,
            isfuncao: 1,
            isoperando: 0,
            valorlegenda: this.funcaoSelecionada.valor
          }
        })
        .then(response => {
          this.detalharMaquina(this.maquinaDetalhe)
        })
        .catch(err => {
          if (err.response.status === 403) {
            this.showDismissibleAlert = true
            this.messageAlert = 'Você não possui privilégios para executar essa ação. Favor entrar em contato o responsável pelo sistema'
          } else {
            this.showDismissibleAlert = true
            this.messageAlert = 'Falha ao alterar a Função. Favor entrar em contato o administrador do sistema informando a mensagem: ' + err
          }
        })
      }
    },
    prepararDeletarStatus: function(legenda) {
      this.statusParaApagar = legenda
      this.tituloModal = 'Confirmação de Exclusão de Status'
      this.mensagemModal = 'Tem certeza que deseja excluir o Status? Essa operação não poderá ser desfeita!'
    },
    deletarStatus: function(legenda) {
      this.$store.dispatch('deleteLegenda', legenda.id)
      .then(response => {
        this.detalharMaquina(this.maquinaDetalhe)
      })
      .catch(err => {
        if (err.response.status === 403) {
          this.showDismissibleAlert = true
          this.messageAlert = 'Você não possui privilégios para executar essa ação. Favor entrar em contato o responsável pelo sistema'
        } else {
          this.showDismissibleAlert = true
          this.messageAlert = 'Falha ao excluir o Status. Favor entrar em contato o administrador do sistema informando a mensagem: ' + err
        }
      })
    },
    atualizarStatus: function() {
      let valorLegendaAlterada = (this.statusSelecionado.in1 ? 1 : 0) +
        (this.statusSelecionado.in2 ? 2 : 0) +
        (this.statusSelecionado.in3 ? 4 : 0) +
        (this.statusSelecionado.in4 ? 8 : 0) +
        (this.statusSelecionado.in5 ? 16 : 0) +
        (this.statusSelecionado.in6 ? 32 : 0)
      if (this.statusSelecionado.id === 0) {
        this.$store.dispatch('createLegenda', {
          textolegenda: this.statusSelecionado.textolegenda,
          idcontrolador: this.statusSelecionado.idcontrolador,
          isfuncao: 0,
          isoperando: this.statusSelecionado.isoperando ? 1 : 0,
          valorlegenda: valorLegendaAlterada
        })
        .then(response => {
          this.detalharMaquina(this.maquinaDetalhe)
        })
        .catch(err => {
          if (err.response.status === 403) {
            this.showDismissibleAlert = true
            this.messageAlert = 'Você não possui privilégios para executar essa ação. Favor entrar em contato o responsável pelo sistema'
          } else {
            this.showDismissibleAlert = true
            this.messageAlert = 'Falha ao criar o Status. Favor entrar em contato o administrador do sistema informando a mensagem: ' + err
          }
        })
      } else {
        this.$store.dispatch('updateLegenda', {
          id: this.statusSelecionado.id,
          legenda: {
            textolegenda: this.statusSelecionado.textolegenda,
            idcontrolador: this.statusSelecionado.idcontrolador,
            isfuncao: 0,
            isoperando: this.statusSelecionado.isoperando ? 1 : 0,
            valorlegenda: valorLegendaAlterada
          }
        })
        .then(response => {
          this.detalharMaquina(this.maquinaDetalhe)
        })
        .catch(err => {
          if (err.response.status === 403) {
            this.showDismissibleAlert = true
            this.messageAlert = 'Você não possui privilégios para executar essa ação. Favor entrar em contato o responsável pelo sistema'
          } else {
            this.showDismissibleAlert = true
            this.messageAlert = 'Falha ao alterar o Status. Favor entrar em contato o administrador do sistema informando a mensagem: ' + err
          }
        })
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Maquinas.vue?16b522fc